import React, { useState, FC, useEffect } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useCceDetailModel } from "../cceDetailModel";
import { customerService } from "@/views/base/customer/customerService";
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import moment from "moment";


export const FormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal,
    } = useCceDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);

    const { fetchCustomerList, fetchSalesList } = useGlobalModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => []);
    const { beShopDs,isEditable} = useGlobalModel(({ beShopDs }) => [beShopDs]);
    const formVal = mode === "edit" ? editFormVal : addFormVal;

    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            customerId: retData.id,
            phone: retData.phone,
            contact: retData.contact,
            countryCode: retData.countryCode,
            countryName: retData.countryName
        }
        updateFormVal(mode, data);
    }

    //出口商选中
    const bentityChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { bentityCode: option.value, bentityName: option.label });
    }

    //币种选中
    const currencyChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { currencyCode: option.value, currencyName: option.label });
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    // 基础信息
    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "信用证号",
                fieldName: "code",
                rules: [{ required: true, message: "请填写信用证号" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "业务员",
                fieldName: "opener",
                // options: [],
                // onSelectChange: currencyChange,
                rules: [{ required: true, message: "请输入业务员" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityCode",
                onSelectChange: bentityChange,
                options: beShopDs,
                rules: [{ required: true, message: "请选择销售实体" }],
            }, {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "外贸合同号",
                fieldName: "saleRealCode",
                selectfetchList: fetchSalesList,
                // onSelectChange: saleCodeChange,
                // rules: [{ required: true, message: "请选择外贸合同号" }],
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "到证日期",
                fieldName: "confirmTime",
                format: "YYYY-MM-DD",
                rules: [{ required: true, message: "请选择到证日期" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "签发日期",
                fieldName: "signingTime",
                format: "YYYY-MM-DD",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "币种",
                fieldName: "currency",
                options: getSelectedDictOne(DictCodeEnmu.CURRENCY),
                // onSelectChange: currencyChange,
                rules: [{ required: true, message: "请选择币种" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开证金额",
                fieldName: "amount",
                rules: [{ required: true, message: "请填写开证金额" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "通知日期",
                fieldName: "informTime",
                format: "YYYY-MM-DD",
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "最迟船期",
                fieldName: "sailSchedule",
                format: "YYYY-MM-DD",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "信用证类型",
                fieldName: "creditType",
                options: getSelectedDictOne(DictCodeEnmu.EXPORT_CREDIT_TYPE),
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "交单日期",
                fieldName: "presentationTime",
                format: "YYYY-MM-DD",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "是否收汇",
                fieldName: "isReceipt",
                options: [{
                    label: '是',
                    value: 1
                }, {
                    label: '否',
                    value: 0
                }],
                rules: [{ required: true, message: "请选择是否收汇" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "收汇日期",
                fieldName: "receiptTime",
                format: "YYYY-MM-DD",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收汇金额",
                fieldName: "receiptPrice",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            },
            //带出
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "币种名称",
            //     fieldName: "currencyName",
            //     hidden: true
            // },
        ]
    };

    // 系统信息
    const systemFormItem: IYhFormItemsBox = {
        title: "系统信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: isEditable
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: isEditable
            }
        ]
    }

    const stockEntryFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: {
            ...formVal,
            confirmTime: formVal?.confirmTime ? moment(formVal?.confirmTime) : null,
            signingTime: formVal?.signingTime ? moment(formVal?.signingTime) : null,
            informTime: formVal?.informTime ? moment(formVal?.informTime) : null,
            presentationTime: formVal?.presentationTime ? moment(formVal?.presentationTime) : null,
            receiptTime: formVal?.receiptTime ? moment(formVal?.receiptTime) : null,
            sailSchedule: formVal?.sailSchedule ? moment(formVal?.sailSchedule) : null,
        },
        onChange,
        boxs: [baseFormItem, systemFormItem]
    }


    return (
        <YhFormBox {...stockEntryFromConfig} />
    )
}